import React, { useState, useEffect } from "react"
import News from "../../components/News/"
import BreadCrum from "../../components/Breadcrumb"
import TitleBlock from "../../components/TitleBlock"
import Layout from "../../components/Layout"
import Pagination from "../../components/Pagination"
import { useAxiosClient } from "../../Services/UseAxiosClient"
import defaultImage from "../../images/news-logo.jpg"
import { Fragment } from "react"

const ExclusiveNews = () => {
  const [page, setPage] = useState()
  const [featuredNews, setFeaturedNews] = useState({})
  const [newsList, setNewsList] = useState([])
  const [totalPages, setTotalPages] = useState(10)

  const getPage = numPage => {
    setPage(numPage)
  }
  const path = [{ label: "Inicio", to: "/" }, { label: "Noticias exclusivas" }]

  const renderNews = () => {
    return (
      newsList &&
      newsList.map((item, index) => (
        <News
          key={`New-${index}-${item.id || item.pk}`}
          text={item.title}
          date={item.publication_date}
          image={item.block1_image || defaultImage}
          className="col-12 col-sm-6"
          link={`/noticias-exclusivas/${item.pk}/${item.slug}`}
          id={item?.id || item?.pk}
        />
      ))
    )
  }

  const [{ data }] = useAxiosClient({
    url: "/publications/news-last-featured/",
    method: "GET",
    params: {
      category: "1,2,3,5,6,7,9,12,14,15",
      order_featured: 1
    },
  })

  const [, triggerGetNews] = useAxiosClient({}, { manual: true })

  useEffect(() => {
    if (data && data.length) {
      const [allData = {}] = data
      setFeaturedNews(allData)
      setPage(1)
    }
  }, [data])

  useEffect(() => {
    const updatedData = () => {
      triggerGetNews({
        url: `/publications/news/`,
        method: "GET",
        params: {
          page,
          nitems: 22,
          noid: featuredNews?.id,
          intranet: 1,
          category: "1,2,3,5,6,7,9,12,14,15",
        },
      }).then(({ data: recived }) => {
        if (!recived) return null
        setTotalPages(prev =>
          prev === recived.total_pages ? prev : recived.total_pages
        )
        setNewsList(recived.items)
      })
    }

    updatedData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page])

  const renderPagination = () => {
    if (totalPages <= 1) {
      return (
        <div className="BibliographicRecommendation-wrapper">
          <div className="row">{renderNews()}</div>
        </div>
      )
    }
    return (
      <Fragment>
        <Pagination
          currentPage={page || 1}
          totalPages={totalPages}
          getPage={getPage}
        />
        <div className="BibliographicRecommendation-wrapper">
          <div className="row">{renderNews()}</div>
        </div>
        <Pagination
          currentPage={page || 1}
          totalPages={totalPages}
          getPage={getPage}
        />
      </Fragment>
    )
  }
  return (
    <Layout>
      <div className="BibliographicRecommendation">
        <BreadCrum path={path} />
        <TitleBlock title="Noticias exclusivas" icon="fas fa-newspaper" />
        <News
          className="BibliographicRecommendation large"
          text={featuredNews?.title}
          content={featuredNews?.summary}
          date={featuredNews?.publication_date}
          image={featuredNews?.block1_image || defaultImage}
          link={`/noticias-exclusivas/${featuredNews.pk}/${featuredNews.slug}`}
          id={featuredNews?.id || featuredNews?.pk}
        />
        {renderPagination()}
      </div>
    </Layout>
  )
}

export default ExclusiveNews
